import { render, staticRenderFns } from "./Bubbelsortering.vue?vue&type=template&id=a738c81e&scoped=true&"
import script from "./Bubbelsortering.vue?vue&type=script&lang=js&"
export * from "./Bubbelsortering.vue?vue&type=script&lang=js&"
import style0 from "./Bubbelsortering.vue?vue&type=style&index=0&id=a738c81e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a738c81e",
  null
  
)

export default component.exports